export default __webpack_public_path__ + "static/media/pdf.22505b81.svg";